module.exports = __webpack_public_path__ + "static/logo-d673040591f04258ed5be969090546ce.svg";